const BaseController = require('base/controller/loadDataController'),
    LoginView = require('./loginView');

const Controller = BaseController.extend({
    unauthorized: true,
    data: function () {
        return {
            serverUpCheck: { data: `/login/serverUpCheck` }
        };
    },
    render: function () {
        let view = new LoginView();
        return view;
    }
});

module.exports = new Controller();
